import { isPackageBanner } from "@/features/flights/hooks/flightSearch/utils";
import type {
  FullOfferType,
  MappedFlightOffer,
} from "@/features/flights/types/types";

type FlightsOverviewItem = MappedFlightOffer["flightsOverview"][number];

/**
 * Removes duplicate flightsOverview items across all offers using the key
 * returned by `getKey`. The first offer to claim a key wins; subsequent offers
 * whose overview items are all already-seen are dropped entirely.
 * Banners and items with an undefined key always pass through unchanged.
 */
export function deduplicateOffersByFlightKey(
  offers: FullOfferType[],
  getKey: (fo: FlightsOverviewItem) => string | undefined,
): FullOfferType[] {
  const seenKeys = new Set<string>();
  const collapsed: FullOfferType[] = [];

  for (const offer of offers) {
    if (isPackageBanner(offer)) {
      collapsed.push(offer);
      continue;
    }

    const filteredOverview = offer.flightsOverview.filter((fo) => {
      const key = getKey(fo);
      if (key === undefined) return true;
      if (seenKeys.has(key)) return false;

      seenKeys.add(key);
      return true;
    });

    if (filteredOverview.length === 0) continue;

    collapsed.push({ ...offer, flightsOverview: filteredOverview });
  }

  return collapsed;
}
